import { Typography, Dropdown, Menu, Button, Input, Avatar } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  MinusCircleFilled,
} from "@ant-design/icons";
import React, { useContext, useEffect, useRef, useState } from "react";
import UserImage from "../../assets/images/avatar.png";
import FiltterIcon from "../../assets/images/filtter-icon-vertical.svg";
import SendIcon from "../../assets/images/send-message.svg";
import EditIcon from "../../assets/images/edit-icon.svg";
import BackErrowIcon from "../../assets/images/arrow_back.svg";
import ErrowUp from "../../assets/images/chat-errow.svg";
import ErrowUpRight from "../../assets/images/chat-right-arrow.svg";
import ErrowUpLink from "../../assets/images/chat-errow-link.svg";
import ExclaimationIcon from "../../assets/images/exclaimation-circle.svg";
import ReadIcon from "../../assets/images/dropdawn-icon/read-icon.svg";
import UnreadIcon from "../../assets/images//dropdawn-icon/Unread-icon.svg";
import NewChatIcon from "../../assets/images/dropdawn-icon/New-chat-icon.svg";
import PendingIcon from "../../assets/images/dropdawn-icon/Pending-icon.svg";
import OngoingIcon from "../../assets/images/dropdawn-icon/Done-Read-Icon.svg";
import SearchIcon from "../../assets/images/new-search-icon-HJ.png";
import SupportImg from "../../assets/images/Support-white.svg";
import useRequest from "../../hooks/useRequest";
import { AuthContext } from "../../context/AuthContext";
import { getSocket } from "../../helper/socket";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import useDebounce from "../../hooks/useDebounce";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { ShowToast ,Severty } from "../../helper/toast";

function ChatIndex() {
  const [selectedUser, setSelectedUser] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [messages, setMessages] = useState([]);
  const [userData, setUserData] = useState([]);
  const [chatData, setChatData] = useState([]);
  const [tempUser, setTempUser] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [phoneChat, setPhoneChat] = useState("");
  const [nameChat, setNameChat] = useState("");

  const [message, setMessage] = useState("");
  const location = useLocation();
  const data = location.state;
  const { userProfile } = useContext(AuthContext);
  const socket = getSocket();
  const chatBodyRef = useRef(null);
  const { request } = useRequest();

  const scrollToBottom = () => {
    chatBodyRef.current.scroll({
      top: chatBodyRef.current.scrollHeight,
      behavior: "instant",
    });
  };
  const handleClose = () => {
    setIsVisible(false); // Hide the error message
  };

  useEffect(() => {
    if (userProfile?._id) {
      socket.emit("online", { userId: userProfile._id });
      socket.on("message", (newMessage = []) => {
        setMessages((prevMessages) => {
          const lastMessage = prevMessages[prevMessages?.length - 1];
          if (lastMessage) {
            const lastMessageDate = moment(lastMessage._id, "YYYY-MM-DD");
            const currentDate = moment().format("YYYY-MM-DD");
            if (lastMessageDate.isSame(currentDate)) {
              lastMessage.messages = [...lastMessage.messages, ...newMessage];
              return [...prevMessages];
            } else {
              return [
                ...prevMessages,
                {
                  _id: currentDate,
                  messages: newMessage,
                },
              ];
            }
          }
          return [
            ...prevMessages,
            {
              _id: moment().format("YYYY-MM-DD"),
              messages: newMessage,
            },
          ];
        });
      });
      socket.on("chatUserList", (data) => {
        console.log("chatUserList", data);

        setAllUsers(data);
        setTempUser(data);
      });
    }
  }, [userProfile]);

  // useEffect(() => {
  //   if (selectedUser?._id) {
  //     setMessages([]);
  //     socket.emit(
  //       "setChat",
  //       { roomId: selectedUser._id, userId: userProfile._id },
  //       (previousMessages) => {
  //         setMessages(previousMessages);
  //       }
  //     );
  //   }
  // }, [selectedUser]);

  const handleSendMessage = () => {
    if (message.trim() && phoneChat && nameChat) {
      const payload = {
        mobileNumber : phoneChat,
        name : nameChat,
      }
      setLoading(true);
      request({
        url: `${apiPath.sendMessages}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          console.log(data);
          setTimeout(() => {
            checkChats(selectedUser);
          },500);
        },
        onError: (error) => {
          ShowToast(error?.response?.data?.message, Severty.ERROR);
          setLoading(false);
        },
      });
      
      // const msgData = {
      //   tutorId: userProfile._id,
      //   senderId: userProfile._id,
      //   studentId: selectedUser.user._id,
      //   message: message,
      //   chatRoomId: selectedUser._id,
      //   type: "tutor",
      // };
      // socket.emit("sendMessage", msgData);

      setMessage("");
    }
  };
  useEffect(() => {
    if (messages?.length) {
      scrollToBottom();
    }
  }, [messages]);
  const getLastSeenLabel = (lastActiveDate) => {
    const now = new Date();
    const lastActive = new Date(lastActiveDate);
    const diffInMinutes = Math.floor((now - lastActive) / (1000 * 60)); // Difference in minutes

    if (diffInMinutes < 1) return "Not online at the moment";
    if (diffInMinutes < 60) return `Active ${diffInMinutes} minutes ago`;
    const hours = Math.floor(diffInMinutes / 60);
    if (hours < 24) return `Active ${hours} hours ago`;
    const days = Math.floor(hours / 24);
    return `Active ${days} days ago`;
  };

  const [selectedKey, setSelectedKey] = useState("1"); // Default selected item
  const [search, setSearch] = useState(""); // Default selected item

  const handleMenuClick = (e) => {
    //1 - unread & read
    //2 - unread only
    //3 - read only
    //4 - ongoing hours
    //5 - completed hours

    const temp = JSON.parse(JSON.stringify(tempUser));

    let filteredUsers = [];
    if (e.key == "1") {
      filteredUsers = temp;
    }
    if (e.key == "2") {
      filteredUsers = temp.filter((user) => {
        return user.unreadCount > 0;
      });
    }
    if (e.key == "3") {
      filteredUsers = temp.filter((user) => {
        return user.unreadCount == 0;
      });
    }
    if (e.key == "4") {
      filteredUsers = temp.filter((user) => {
        return user?.booking?.status == "ongoing";
      });
    }
    if (e.key == "5") {
      filteredUsers = temp.filter((user) => {
        return user?.booking?.status == "completed";
      });
    }

    setSelectedKey(e.key);
    setAllUsers(filteredUsers);
  };
  const menu = (
    <Menu onClick={handleMenuClick} className="main-new-filter-chat-drop">
      <Menu.Item
        className={`filter-drop-listing ${selectedKey === "1" ? "active" : ""}`}
        key="1"
      >
        <div className="main-new-drop-icon-imgg">
          <img src={ReadIcon} alt="Icon" style={{ width: 20 }} />
          Unread & read
        </div>
        {selectedKey === "1" && <CheckOutlined style={{ float: "right" }} />}
      </Menu.Item>
      <Menu.Item
        className={`filter-drop-listing ${selectedKey === "2" ? "active" : ""}`}
        key="2"
      >
        <div className="main-new-drop-icon-imgg">
          <img src={UnreadIcon} alt="Icon" style={{ width: 20 }} />
          Unread only
        </div>
        {selectedKey === "2" && <CheckOutlined style={{ float: "right" }} />}
      </Menu.Item>
      <Menu.Item
        className={`filter-drop-listing ${selectedKey === "3" ? "active" : ""}`}
        key="3"
      >
        <div className="main-new-drop-icon-imgg">
          <img src={NewChatIcon} alt="Icon" style={{ width: 20 }} />
          New chats{" "}
        </div>
        {selectedKey === "3" && <CheckOutlined style={{ float: "right" }} />}
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    const updateView = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", updateView);
    updateView();

    return () => window.removeEventListener("resize", updateView);
  }, []);

  const handleBookDone = (id) => {
    request({
      url: apiPath.bookingDone + id,
      method: "Post",
      onSuccess: (data) => {
        if (data.status === 200) {
          setSelectedUser((prev) => ({ ...prev, booking: data.data }));
        }
      },
    });
  };

  const handleSearch = (query) => {
    if (query && query.trim()) {
      const regex = new RegExp(query, "i");
      const filteredUsers = tempUser.filter((user) => {
        return regex.test(user?.user?.name) || regex.test(user?.user?.name);
      });
      setAllUsers(filteredUsers);
    } else {
      setAllUsers(tempUser);
    }
  };
  const debouncedSearch = useDebounce(handleSearch, 500);
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  useEffect(() => {
    if (
      data?.inquireId &&
      tempUser?.length &&
      !Object.keys(selectedUser)?.length
    ) {
      setSelectedUser(
        tempUser.find((user) => user.inquiryId === data?.inquireId)
      );
    }
  }, [tempUser, data?.inquireId]);

  useEffect(() => {
    request({
      url: `${apiPath.getContacts}`,
      method: "get",
      onSuccess: (data) => {
        setLoading(false);
        setUserData(data.data?.contact_list);       
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  }, []);

  const checkChats = (user) => {
    setNameChat(user.fullName)
    setPhoneChat(user.phone)
    const payload = {
     mobileNumber : user.phone
    }
    setChatData([])
    setLoading(true);
    request({
     url: `${apiPath.getMessages}`,
     method: "POST",
     data: payload,
     onSuccess: (data) => {
       setLoading(false);
       if (data.status) {
        if(data.data.result){
          ShowToast(data.message, Severty.SUCCESS);
          setChatData(data.data.messages.items,"checkkkk")  
        }else{
          ShowToast(data.data.info, Severty.ERROR);
        }
       } else {
         ShowToast(data.message, Severty.ERROR);
       }
     },
     onError: (error) => {
       ShowToast(error?.response?.data?.message, Severty.ERROR);
       setLoading(false);
     },
    });
  } 

  return (
    <>
      {
        <div className="chat-app">
          <div
            className="message-list"
            style={{
              display:
                !selectedUser || window.innerWidth >= 768 ? "block" : "none",
            }}
          >
            <h6 className="message-card-headding">Messages</h6>
            <div className="user-list-header">
              <Input
                type="text"
                placeholder="Search"
                value={search}
                className="chatlist-search-bar"
                onChange={handleSearchChange}
                prefix={
                  <span>
                    <img src={SearchIcon} alt="Search" />
                  </span>
                }
              />
              <Dropdown
                placement="bottomRight"
                overlay={menu}
                trigger={["click"]}
              >
                <Button className="filter-btn">
                  <img src={FiltterIcon} alt="Filter" />
                </Button>
              </Dropdown>
            </div>
            <div className="chatuser-listing">

            {userData?.length > 0 &&
                  userData.map((user) => (
                <div className={`message-item selected `}
                onClick={() => { checkChats(user); setSelectedUser(user) }}>
                  <div className={`user-chatprofile active `}>
                    <img src={UserImage} alt="Avatar" className="user-images " />
                    <span className="main-new-chat-active-icon inactive"></span>
                  </div>

                      <div className="message-info">
                        <h4>
                          <div className="chat-user-name">{user.fullName}</div>
                          {/* <span className={`chat-active-userstatus`}>
                            Active 2 days ago
                          </span> */}
                        </h4>
                        <p>{user.phone}</p>
                      </div> 


                  {/* <span className="unread-count">2</span> */}
                </div>
                
              ))
          }


                
            </div>
          </div>



          {nameChat && phoneChat && (
            <div
              className="chat-window"
              style={{
                display: selectedUser || window.innerWidth >= 768 ? "block" : "none",
              }}
            >
              <>
                {window.innerWidth < 768 && (
                  <div className="back-errow-btn" onClick={() => { 
                      setSelectedUser(null);
                      checkChats([]);
                      setNameChat("");
                      setPhoneChat("");
                     } }>
                    <img src={BackErrowIcon} /> Back
                  </div>
                )}

                <div className="chat-header">
                  <div className="user-info">
                    <div className="chat-dp-user">
                      <img src={UserImage} alt="User" className="user-image" />
                    </div>

                    <div className="user-name-details">
                      <h3>{nameChat}</h3>
                      <p>+{phoneChat}</p>
                    </div>
                  </div>
                </div>

                <div className="chat-body">
                  {chatData?.length > 0 &&
                    [...chatData] // Copy array to avoid mutation
                      .sort(
                        (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
                      ) // Sorting in descending order
                      .map((chat, index) => {
                        // Extract date and time
                        const chatDate = moment(chat.created).format("DD MMM YYYY");
                        const chatTime = moment(chat.created).format("hh:mm A");

                        return (
                          <div key={chat.id}>
                            {/* Show Date Header when Date Changes */}
                            {(index === 0 ||
                              moment(chat.created).format("DD MMM YYYY") !==
                                moment(chatData[index - 1]?.created).format("DD MMM YYYY")) && (
                              <div className="main-new-date-yesterday">{chatDate}</div>
                            )}

                            <div
                              className={`chat-message ${
                                chat.eventType === "broadcastMessage" ? "self" : "other"
                              }`}
                            >
                              <div className="chat-profile-image">
                                <img
                                  src={UserImage}
                                  alt={`Profile`}
                                  className="profile-image"
                                />
                              </div>
                              <div className="chat-name-and-time-main">
                                <div className="chat-name-and-time">
                                  <h4>
                                    {chat.eventType === "broadcastMessage" ? (
                                      <>
                                        You <span className="chat-user-name">Support</span>
                                      </>
                                    ) : (
                                      <span className="chat-user-name">User</span>
                                    )}
                                  </h4>
                                </div>
                                <p className={`main-chat-message`}>
                                  <img className="arrow-chat" src={ErrowUp} />
                                  <img className="arrow-chat-right" src={ErrowUpRight} />
                                  {chat.finalText}
                                </p>
                                {/* Failed Icon when message status is "FAILED" */}
                                {chat.statusString === "FAILED" && (
                                  <div className="failed-message">
                                    <MinusCircleFilled/>
                                    <span className="failed-text">Failed to send</span>
                                  </div>
                                )}
                                <span className="message-time">{chatTime}</span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>
                 {nameChat && phoneChat && (
                    <div className="chat-footer">
                      <div className="input-container">
                        <span className="icon-pen">
                          {" "}
                          <img src={EditIcon} />
                        </span>{" "}
                        {/* Pen Icon */}
                        <input
                          type="text"
                          value={message}
                          onChange={(event) => setMessage(event.target.value)}
                          placeholder="Your message....."
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              if (message.trim()) {
                                handleSendMessage();
                              }
                            }
                          }}
                        />
                        <button className="send-button" onClick={handleSendMessage}>
                          <img src={SendIcon} />
                        </button>
                      </div>
                    </div>
                  )}
              </>
            </div>
          )}

        </div>
      }
    </>
  );
}

export default ChatIndex;
